import { Menu, MenuButton, IconButton, MenuList } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Statement } from "hooks/statements/useStatements";
import { StatementMenuItemDelete } from "./StatementMenuItemDelete";

interface StatementMenuProps {
    statement: Statement;
}

export function StatementMenu({ statement }: StatementMenuProps) {
    return (
        <Menu>
            <MenuButton
                as={IconButton}
                aria-label="Options"
                variant={"link"}
                icon={<FontAwesomeIcon icon={["far", "ellipsis-vertical"]} />}
            />
            <MenuList>
                <StatementMenuItemDelete statement={statement} />
            </MenuList>
        </Menu>
    );
}
